// import 'dotenv/config';

export const config = {
  baseName: process.env.REACT_APP_BASE_URL,
  appBaseUrl: process.env.REACT_APP_BASE_URL,
  apiBaseUrl: process.env.REACT_APP_WEBSITE_API_URL,
  localStorageAuthTokenKey: process.env.REACT_APP_STORAGE_SESSION_REFRESH_KEY,
  cryptoSecret: process.env.REACT_APP_CRYPTO_SECRET,
  razorpayKey: process.env.REACT_APP_RAZORPAY_KEY,

};

